
      import("./app/main.tsx")
        .then(() => window.__continuiteaBoot?.clearRetry?.())
        .catch(() => window.__continuiteaBoot?.retryOnce?.());
    